module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag24_1154AT.617bec39.jpg";